export default __webpack_public_path__ + "static/media/bullet.c11bb70f.svg";